/*
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Un popup
 */
/* global Signal */

(function($g, $, Signal) {
    "use strict";
    var waitFor = $g.waitFor;
    var body = $("body");
    var classOnBodyOnActive = "popup-active";

    function waitForDataReady(f) {
        waitFor("hommageData", function(hommageData) {
            hommageData.ready(function() {
                f(hommageData);
            });
        });        
    }

    function time() {
        return new Date().getTime();
    }

    function Popup() {
        var me = this;
        me.container = null;
        me.onHide = new Signal();

        this.addBehaviors = function($div) {
            $div.find(".action-popup-close").click(me.hide);
        };

        this.inject = function($ct, id, replaceMap, options) {
            var $div = $g.template.inject($ct, id, replaceMap, options);
            me.addBehaviors($div);
            return $div;
        };

        this.show = function() {
            body.addClass(classOnBodyOnActive);
            Popup.opened.push(me);
            me.container = me.inject(body, "overlay");
            if ($g.Music) {
                $g.Music.stop();
            }
            waitForDataReady(function(hommageData) {
                hommageData.lock();
            });
        };

        this.hide = function(res) {
            body.removeClass(classOnBodyOnActive);
            var index = Popup.opened.indexOf(me);
            if (index>=0) {
                Popup.opened.splice(index, 1);
            }
            if (me.container){
                $g.template.remove(me.container);
                //me.container.remove();
                me.container = null;
                waitForDataReady(function(hommageData) {
                    hommageData.unlock();
                });
            }
            Popup.lastClose = time();
            me.onHide.trigger(res);
            return false;
        };

    }

    Popup.opened = [];
    Popup.all = {};

    Popup.attach = function($me, target) {
        $me.click(function() {
            Popup.open($me, target, true);
            return false;
        });
    };
    
    Popup.open = function($me, target, inClick) {
        var o = {};
        waitFor($g, "template", Popup.all, target, function(t,cl) {
            if (Popup.opened.length===0) {
                var p = new cl();
                p.dataHref = $me ? $me.data("href") : null;
                p.show(inClick, $me);
                o.a = 1;
            } else {
                o.a = 2;
            }
        });        
        inClick=false;
        return waitFor(o, "a").then(function(v) {
            if (v[0]!==1) {
                return Promise.reject("Il y a déjà un popup d'ouvert");
            }
        }).then(Popup.waitForCurrent);
    };

    Popup.link = function() {
        var $me = $(this);
        var href = $me.attr("href");
        if (href) {
            var target = href.substr(1);
            Popup.attach($me, target);
        } else {
            $g.warning("Le popup à ouvrir n'est pas spécifié ", this);
        }
    };

    Popup.register = function(sel) {
        waitFor($g,"behavior", function(behavior) {
            behavior.add(sel, Popup.link);
        });
    };

    Popup.close = function(res) {
        var opened=Popup.opened[0];
        if (opened) {
            opened.hide(res);
        }
    };

    Popup.waitForCurrent = function() {
        return new Promise(function(accept, reject) {
            var p = Popup.opened[0];
            if (p) {
                p.onHide.once(function(res) {
                    accept(res);
                });
            } else {
                reject();
            }
        });
    };

    /**
     * Attendre qu'il n'y est plus aucun popup
     */
    Popup.waitAll = function() {
        return new Promise(function(accept) {

            function checkForComplete() {
                var opened=Popup.opened[0];
                if (opened) {
                    wait();
                } else {
                    setTimeout(function() {
                        if (Popup.opened[0]) {
                            wait();
                        } else {
                            accept();
                        }
                    },1);
                }
            };

            function wait() {
                Popup.waitForCurrent().then(checkForComplete, checkForComplete);
            }

            wait();
        });
    };

    Popup.register(".action-popup");

    $g.Popup = Popup;
    window.Popup = Popup;

})(PVPGEngine, jQuery, _P.Signal);